










































import { Vue, Component, Prop } from 'vue-property-decorator';
import { ReasonToBuyViewObject } from '@/types/apiServerContract';

import ReadMore from '@/core/ui-components/ReadMore.vue';

@Component({
    components: { ReadMore }
})
export default class ProductDetailsReasonsToBuy extends Vue {
  @Prop({ required: true, type: Array }) reasonsToBuy!: ReasonToBuyViewObject[];
}
